import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _forEach from 'lodash/forEach';
import _includes from 'lodash/includes';
import _set from 'lodash/set';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _keyBy from 'lodash/keyBy';
import _uniq from 'lodash/uniq';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _cloneDeep from 'lodash/cloneDeep';
import { TAX_AND_ZIP_CODE_DETAILS_VS_KEY } from '../constants/desking.constants';
var IN_STATE_RETAIL = 'retailInState.stateConfig';
var IN_STATE_LEASE = 'leaseInState.stateConfig';
var OUT_STATE_RETAIL = 'retailOutState.stateConfig';
var OUT_STATE_LEASE = 'leaseOutState.stateConfig';
var LEASE = TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE,
    RETAIL = TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL;

var getConfigBasedOnPaymentType = function getConfigBasedOnPaymentType(stateConfig) {
  var stateTaxMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var PT = arguments.length > 2 ? arguments[2] : undefined;
  return _map(stateConfig, function (config) {
    var stateId = config.stateId,
        taxes = config.taxes,
        taxPercentages = config.taxPercentages;
    var newTaxes = [];
    var newTaxPcts = [];

    var stateConfigMetadata = _find(stateTaxMetadata, function (_ref) {
      var metadataStateId = _ref.stateId;
      return metadataStateId === stateId;
    });

    var stateTaxOptions = (stateConfigMetadata === null || stateConfigMetadata === void 0 ? void 0 : stateConfigMetadata.taxes) || [];
    var stateTaxPcts = (stateConfigMetadata === null || stateConfigMetadata === void 0 ? void 0 : stateConfigMetadata.taxPercentages) || [];

    _forEach(taxes, function (tax) {
      var paymentTypeByKey = _keyBy(stateTaxOptions, function (_ref2) {
        var key = _ref2.key;
        return key;
      });

      var paymentType = _get(paymentTypeByKey[tax.key], 'paymentType');

      if (_includes(paymentType, PT)) newTaxes.push(tax);
    });

    _forEach(taxPercentages, function (pct) {
      var paymentType = _get(stateTaxPcts.find(function (_ref3) {
        var key = _ref3.key;
        return key === pct.key;
      }), 'paymentType');

      if (_includes(paymentType, PT)) newTaxPcts.push(pct);
    });

    return {
      taxes: newTaxes,
      taxPercentages: newTaxPcts,
      stateId: stateId
    };
  });
};

var splitConfig = function splitConfig(stateConfig, stateTaxMetadata) {
  var retailConfig = getConfigBasedOnPaymentType(stateConfig, stateTaxMetadata, RETAIL);
  var leaseConfig = getConfigBasedOnPaymentType(stateConfig, stateTaxMetadata, LEASE);
  return {
    retailConfig: retailConfig,
    leaseConfig: leaseConfig
  };
};

export var getSplitStateTaxConfigs = function getSplitStateTaxConfigs(stateTaxConfigV2, stateTaxMetadata) {
  var config = _cloneDeep(stateTaxConfigV2);

  var _splitConfig = splitConfig(_get(config, IN_STATE_RETAIL), stateTaxMetadata),
      retailInState = _splitConfig.retailConfig,
      leaseInState = _splitConfig.leaseConfig;

  var _splitConfig2 = splitConfig(_get(config, OUT_STATE_RETAIL), stateTaxMetadata),
      retailOutState = _splitConfig2.retailConfig,
      leaseOutState = _splitConfig2.leaseConfig;

  _set(config, IN_STATE_RETAIL, retailInState);

  _set(config, IN_STATE_LEASE, leaseInState);

  _set(config, OUT_STATE_RETAIL, retailOutState);

  _set(config, OUT_STATE_LEASE, leaseOutState);

  return config;
};

var mergeConfig = function mergeConfig(retailConfig, leaseConfig) {
  var retailConfigByState = _keyBy(retailConfig, function (_ref4) {
    var stateId = _ref4.stateId;
    return stateId;
  });

  var leaseConfigByState = _keyBy(leaseConfig, function (_ref5) {
    var stateId = _ref5.stateId;
    return stateId;
  });

  var allStateKeys = _uniq([].concat(_toConsumableArray(_keys(retailConfigByState)), _toConsumableArray(_keys(leaseConfigByState))));

  return _map(allStateKeys, function (stateId) {
    var _ref6 = retailConfigByState[stateId] || {},
        _ref6$taxes = _ref6.taxes,
        retailTax = _ref6$taxes === void 0 ? [] : _ref6$taxes,
        _ref6$taxPercentages = _ref6.taxPercentages,
        retailTaxPercentages = _ref6$taxPercentages === void 0 ? [] : _ref6$taxPercentages;

    var _ref7 = leaseConfigByState[stateId] || {},
        _ref7$taxes = _ref7.taxes,
        leaseTax = _ref7$taxes === void 0 ? [] : _ref7$taxes,
        _ref7$taxPercentages = _ref7.taxPercentages,
        leaseTaxPercentages = _ref7$taxPercentages === void 0 ? [] : _ref7$taxPercentages;

    var leaseTaxNotPresentInRetail = _filter(leaseTax, function (_ref8) {
      var leaseKey = _ref8.key;
      return !_find(retailTax, function (_ref9) {
        var retailKey = _ref9.key;
        return leaseKey === retailKey;
      });
    }) || [];
    var leaseTaxPctNotPresentInRetail = _filter(leaseTaxPercentages, function (_ref10) {
      var leaseKey = _ref10.key;
      return !_find(retailTaxPercentages, function (_ref11) {
        var retailKey = _ref11.key;
        return leaseKey === retailKey;
      });
    }) || [];
    var newTaxes = [].concat(_toConsumableArray(retailTax), _toConsumableArray(leaseTaxNotPresentInRetail));
    var newTaxPcts = [].concat(_toConsumableArray(retailTaxPercentages), _toConsumableArray(leaseTaxPctNotPresentInRetail));
    return {
      stateId: stateId,
      taxes: newTaxes,
      taxPercentages: newTaxPcts
    };
  });
};

export var getMergedStateTaxConfigs = function getMergedStateTaxConfigs(stateTaxConfigV2) {
  var config = _cloneDeep(stateTaxConfigV2);

  var inStateConfig = mergeConfig(_get(config, IN_STATE_RETAIL), _get(config, IN_STATE_LEASE));
  var outStateConfig = mergeConfig(_get(config, OUT_STATE_RETAIL), _get(config, OUT_STATE_LEASE));

  _set(config, IN_STATE_RETAIL, inStateConfig);

  _set(config, OUT_STATE_RETAIL, outStateConfig);

  return config;
};